import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LogoComponent } from '../logo/logo.component';

interface LaunchVideo { title: string; description: string; file: string; poster: string; }
const BASE = 'https://storage.googleapis.com/hostel-hop-public-storage/marketing/owner-launch-2026-10/';
const VIDEOS: Record<string, LaunchVideo> = {
  partner: { title: 'Booking options for your hostel', description: 'Add a booking widget to your website or use a hosted booking page.', file: BASE + 'partner.mp4', poster: BASE + 'partner-poster.jpg' },
  multileg: { title: 'Plan a multi-stop trip', description: 'Choose your cities, dates, hostels and rooms in one itinerary.', file: BASE + 'multileg.mp4', poster: BASE + 'multileg-poster.jpg' },
};

@Component({
  selector: 'app-launch-video', standalone: true, imports: [CommonModule, LogoComponent],
  templateUrl: './launch-video.component.html', styleUrl: './launch-video.component.scss',
})
export class LaunchVideoComponent implements AfterViewInit, OnDestroy {
  @ViewChild('player', { static: true }) player!: ElementRef<HTMLDialogElement>;
  video: LaunchVideo | null = null;
  private navigation?: Subscription;
  constructor(private router: Router, private cd: ChangeDetectorRef, @Inject(PLATFORM_ID) private platform: object) {}
  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platform)) return;
    this.navigation = this.router.events.subscribe(event => { if (event instanceof NavigationEnd) this.sync(); });
    this.sync();
  }
  private sync() {
    const url = this.router.parseUrl(this.router.url);
    const key = url.queryParams['watch'];
    const selected = Object.prototype.hasOwnProperty.call(VIDEOS, key) ? VIDEOS[key] : null;
    if (!selected) { this.dismiss(); return; }
    if (this.video === selected && this.player.nativeElement.open) return;
    this.video = selected;
    this.cd.detectChanges();
    if (!this.player.nativeElement.open) this.player.nativeElement.showModal();
  }
  close(event?: Event) {
    event?.preventDefault();
    this.dismiss();
    const url = this.router.parseUrl(this.router.url);
    delete url.queryParams['watch'];
    void this.router.navigateByUrl(url, { replaceUrl: true });
  }
  backdrop(event: MouseEvent) {
    if (event.target !== this.player.nativeElement) return;
    const box = this.player.nativeElement.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
  }
  private dismiss() {
    this.player.nativeElement.querySelector('video')?.pause();
    if (this.player.nativeElement.open) this.player.nativeElement.close();
    this.video = null;
    this.cd.detectChanges();
  }
  ngOnDestroy() { this.navigation?.unsubscribe(); }
}
